const COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola',
  'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
  'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados',
  'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
  'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei',
  'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia',
  'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile',
  'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica',
  'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark',
  'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt',
  'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini',
  'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon',
  'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece',
  'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
  'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India',
  'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel',
  'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan',
  'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos',
  'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya',
  'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi',
  'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands',
  'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova',
  'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique',
  'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
  'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea',
  'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau',
  'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru',
  'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania',
  'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia',
  'Saint Vincent and the Grenadines', 'Samoa', 'San Marino',
  'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia',
  'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia',
  'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan',
  'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden',
  'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania',
  'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago',
  'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda',
  'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States',
  'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela',
  'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
];

if (!customElements.get('support-intake')) {
  var TURNSTILE_TIMEOUT_MS = 20000;
  var TURNSTILE_TIMEOUT_MESSAGE =
    'Security verification timed out. Please reload the page and try again, or email support@straum.co and we will pick this up from there.';
  var TURNSTILE_FAILED_MESSAGE =
    'Security verification failed. Please reload the page and try again, or email support@straum.co and we will pick this up from there.';
  var GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

  // The Edge Function answers a validation failure with
  // { ok: false, errors: { <payload field>: <message> } } and a 400. These are
  // the words the form uses for those payload fields, and the input each one
  // maps to. A field that is not here is not one the sender can correct
  // (category) — those fall back to the generic message.
  var FIELDS = {
    name: { label: 'Name', inputs: ['first_name'] },
    email: { label: 'Email', inputs: ['email'] },
    phone: { label: 'Phone', inputs: ['phone'] },
    subject: { label: 'Subject', inputs: ['subject'] },
    message: { label: 'Message', inputs: ['message_question', 'message_detail'] },
    country: { label: 'Country', inputs: ['country'] },
    address1: { label: 'Address', inputs: ['address1'] },
    address2: { label: 'Address line 2', inputs: ['address2'] },
    city: { label: 'City', inputs: ['city'] },
    postcode: { label: 'Postcode', inputs: ['postcode'] },
    order_number: { label: 'Order number', inputs: ['order_number_other', 'order_number'] },
    product: { label: 'Product', inputs: ['product'] },
  };

  class SupportIntake extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-form]');
      this.formArea = this.querySelector('[data-form-area]');
      this.successArea = this.querySelector('[data-success]');
      this.errorBanner = this.querySelector('[data-error]');
      this.errorMessage = this.querySelector('[data-error-message]');
      this.categoryInput = this.querySelector('[data-category]');
      this.submitBtn = this.querySelector('[data-submit]');

      this.turnstileWidgetId = null;
      this.turnstileResolve = null;
      this.turnstileReject = null;
      this._turnstileTimeout = null;

      this.populateCountries();
      this.bindEvents();
      this._initTurnstile();
    }

    populateCountries() {
      const select = this.querySelector('[data-country-select]');
      if (!select) return;
      const fragment = document.createDocumentFragment();
      COUNTRIES.forEach(function (name) {
        var opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name;
        fragment.appendChild(opt);
      });
      select.appendChild(fragment);
    }

    bindEvents() {
      var self = this;

      this.querySelectorAll('[data-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          self.switchTab(tab.dataset.tab);
        });
      });

      this.form.addEventListener('submit', function (e) {
        self.handleSubmit(e);
      });

      this.form.addEventListener('input', function (e) {
        var field = e.target.closest('.support-intake__field');
        if (field) field.classList.remove('support-intake__field--error');
      });

      this.form.addEventListener('change', function (e) {
        var field = e.target.closest('.support-intake__field');
        if (field) field.classList.remove('support-intake__field--error');
      });

      var orderSelect = this.querySelector('[data-order-select]');
      if (orderSelect) {
        var orderOther = this.querySelector('[data-order-other]');
        var orderOtherInput = orderOther ? orderOther.querySelector('input') : null;
        orderSelect.addEventListener('change', function () {
          if (orderSelect.value === 'other') {
            orderOther.hidden = false;
            if (orderOtherInput) orderOtherInput.setAttribute('required', '');
          } else {
            orderOther.hidden = true;
            if (orderOtherInput) {
              orderOtherInput.removeAttribute('required');
              orderOther.classList.remove('support-intake__field--error');
            }
          }
        });
      }
    }

    switchTab(category) {
      this.querySelectorAll('[data-tab]').forEach(function (tab) {
        var isActive = tab.dataset.tab === category;
        tab.classList.toggle('support-intake__tab--active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
      });

      this.categoryInput.value = category;

      var questionPanel = this.querySelector('[data-panel="question"]');
      var detailPanel = this.querySelector('[data-panel="detail"]');

      if (category === 'question') {
        questionPanel.hidden = false;
        detailPanel.hidden = true;
      } else {
        questionPanel.hidden = true;
        detailPanel.hidden = false;
      }

      this.hideError();
      this.form.querySelectorAll('.support-intake__field--error').forEach(function (f) {
        f.classList.remove('support-intake__field--error');
      });
    }

    validate() {
      var errors = [];
      var fields = this.form.querySelectorAll('[required]');

      for (var i = 0; i < fields.length; i++) {
        var field = fields[i];
        if (field.closest('[hidden]')) continue;

        var value = field.value.trim();
        if (!value) {
          errors.push(field);
          continue;
        }

        if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          errors.push(field);
        }
      }

      return errors;
    }

    showError(message) {
      this.showErrors([message]);
    }

    showErrors(messages) {
      this.errorMessage.replaceChildren.apply(
        this.errorMessage,
        messages.map(function (message) {
          var line = document.createElement('p');
          line.textContent = message;
          return line;
        })
      );
      this.errorBanner.hidden = false;
      this.errorBanner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    // Turn a rejected response body into the messages to show. Field errors
    // from the Edge Function are named against their fields and marked on the
    // inputs; anything else (a 500, an unreadable body, a failure naming only
    // fields the sender cannot correct) keeps the generic message.
    showResponseError(data) {
      var errors = data && typeof data.errors === 'object' && data.errors ? data.errors : null;
      var self = this;

      if (errors) {
        var keys = Object.keys(errors).filter(function (key) { return FIELDS[key]; });
        if (keys.length > 0) {
          this.showErrors(keys.map(function (key) {
            return FIELDS[key].label + ': ' + errors[key];
          }));

          var first = null;
          keys.forEach(function (key) {
            var input = self.inputFor(key);
            if (!input) return;
            var wrapper = input.closest('.support-intake__field');
            if (wrapper) wrapper.classList.add('support-intake__field--error');
            if (!first) first = input;
          });
          if (first) first.focus();
          return;
        }
      }

      this.showError((data && data.error) || GENERIC_ERROR_MESSAGE);
    }

    inputFor(key) {
      var names = FIELDS[key] ? FIELDS[key].inputs : [];
      for (var i = 0; i < names.length; i++) {
        var el = this.querySelector('[name="' + names[i] + '"]');
        if (el && !el.closest('[hidden]')) return el;
      }
      return null;
    }

    resetSubmit() {
      this.submitBtn.disabled = false;
      this.submitBtn.textContent = 'Send my request';
      if (this.turnstileWidgetId != null) turnstile.reset(this.turnstileWidgetId);
    }

    hideError() {
      this.errorBanner.hidden = true;
    }

    _initTurnstile() {
      var sitekey = this.dataset.turnstileKey;
      if (!sitekey) return;

      if (typeof turnstile !== 'undefined') {
        this._renderTurnstile();
        return;
      }

      var self = this;
      this._turnstileCheck = setInterval(function () {
        if (typeof turnstile !== 'undefined') {
          clearInterval(self._turnstileCheck);
          self._renderTurnstile();
        }
      }, 200);

      setTimeout(function () { clearInterval(self._turnstileCheck); }, 10000);
    }

    _renderTurnstile() {
      var container = this.querySelector('[data-turnstile]');
      var sitekey = this.dataset.turnstileKey;
      if (!container || !sitekey) return;

      var self = this;
      this.turnstileWidgetId = turnstile.render(container, {
        sitekey: sitekey,
        size: 'flexible',
        execution: 'execute',
        callback: function (token) {
          self._settleTurnstile(token);
        },
        'error-callback': function () {
          self._failTurnstile(TURNSTILE_FAILED_MESSAGE);
        },
        'timeout-callback': function () {
          self._failTurnstile(TURNSTILE_FAILED_MESSAGE);
        },
        'expired-callback': function () {
          self._failTurnstile(TURNSTILE_FAILED_MESSAGE);
        }
      });
    }

    _settleTurnstile(token) {
      if (!this.turnstileResolve) return;
      var resolve = this.turnstileResolve;
      this._clearTurnstilePending();
      resolve(token);
    }

    _failTurnstile(message) {
      if (!this.turnstileReject) return;
      var reject = this.turnstileReject;
      this._clearTurnstilePending();
      reject(new Error(message));
    }

    _clearTurnstilePending() {
      clearTimeout(this._turnstileTimeout);
      this._turnstileTimeout = null;
      this.turnstileResolve = null;
      this.turnstileReject = null;
    }

    // Cloudflare can decide a submission needs an interactive challenge. If that
    // challenge never completes, neither the callback nor the error-callback
    // fires, so the promise has to time out on its own — otherwise the form waits
    // forever with no message. See TURNSTILE_TIMEOUT_MS.
    _executeTurnstile() {
      var self = this;
      return new Promise(function (resolve, reject) {
        if (self.turnstileWidgetId == null) {
          reject(new Error('Security verification not available. Please refresh the page and try again.'));
          return;
        }
        self.turnstileResolve = resolve;
        self.turnstileReject = reject;
        self._turnstileTimeout = setTimeout(function () {
          self._failTurnstile(TURNSTILE_TIMEOUT_MESSAGE);
        }, TURNSTILE_TIMEOUT_MS);
        turnstile.execute(self.turnstileWidgetId);
      });
    }

    async handleSubmit(e) {
      e.preventDefault();

      var errors = this.validate();
      if (errors.length) {
        errors.forEach(function (field) {
          var wrapper = field.closest('.support-intake__field');
          if (wrapper) wrapper.classList.add('support-intake__field--error');
        });
        this.showError('Please fill in all required fields.');
        errors[0].focus();
        return;
      }

      this.submitBtn.disabled = true;
      this.submitBtn.textContent = 'Sending…';
      this.hideError();

      try {
        var data = new FormData(this.form);
        var category = data.get('category');

        var payload = {
          category: category,
          name: (data.get('first_name').trim() + ' ' + data.get('last_name').trim()).trim(),
          email: data.get('email').trim()
        };

        var phone = data.get('phone').trim();
        if (phone) payload.phone = phone;

        if (category === 'question') {
          payload.subject = data.get('subject').trim();
          payload.message = data.get('message_question').trim();
        } else {
          payload.country = data.get('country');
          payload.address1 = data.get('address1').trim();
          var addr2 = data.get('address2').trim();
          if (addr2) payload.address2 = addr2;
          payload.city = data.get('city').trim();
          payload.postcode = data.get('postcode').trim();
          var orderNum = data.get('order_number').trim();
          if (orderNum === 'other') orderNum = data.get('order_number_other').trim();
          payload.order_number = orderNum;
          payload.product = data.get('product').trim();
          payload.message = data.get('message_detail').trim();
        }

        var token = await this._executeTurnstile();
        if (token) payload.turnstile_token = token;

        var endpoint = this.dataset.endpoint;
        var response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          var errorData = null;
          try { errorData = await response.json(); } catch (_) { /* ignore */ }
          this.showResponseError(errorData);
          this.resetSubmit();
          return;
        }

        this.formArea.hidden = true;
        this.successArea.hidden = false;
        this.successArea.scrollIntoView({ behavior: 'smooth', block: 'start' });

      } catch (err) {
        this.showError(err.message || GENERIC_ERROR_MESSAGE);
        this.resetSubmit();
      }
    }
  }

  customElements.define('support-intake', SupportIntake);
}
